export const readFundedAccounts = (state) => {
  return state.fundedAccounts.read;
};
